import { useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { Verification } from 'components/login/Verification'
import { useFetch } from 'services/useFetch'
import { API } from 'services/api'
import { Alert } from 'avo-ui'
import { OTP_VALIDATION } from 'services/validation/verificationValidation'

export const VerificationContainer = ({ show, setShow, recaptchaRef, setValueCaptcha }) => {
    const [OTP, setOTP] = useState('')
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: OTP,
        schema: OTP_VALIDATION,
    })
    const { fetching: postVerifyLogin, isLoading } = useFetch(API.VERIFY_LOGIN)

    const setShowAlert = (message) => {
        return Alert({
            icon: 'error',
            title: 'Authentication Error !',
            message,
        })
    }

    const onChangeOTP = (value) => {
        setOTP(value)
    }

    const closeModal = () => {
        setValueCaptcha(null)
        recaptchaRef?.current?.reset()
        setShow(false)
        clearErrorForm()
    }

    const onSubmit = () => {
        const payload = { otp_code: Number(OTP) }
        validateForm().then(() => {
            postVerifyLogin(payload)
                .then((response) => {
                    localStorage.setItem('identifier', response?.data?.mas_identifier)
                    localStorage.setItem('is_login', 'yes')
                    window.location.reload()
                })
                .catch((err) => {
                    switch (err.code) {
                        case '401-A007':
                            closeModal()
                            setShowAlert('Kode OTP yang di inputkan melebihi limit, silahkan login kembali')
                            break
                        case '401-A008':
                            setShowAlert('Kode OTP yang di inputkan tidak valid')
                            break
                        case '401-A013':
                            closeModal()
                            setShowAlert('Kode OTP expired, silahkan login kembali')
                            break
                        default:
                            return
                    }
                })
        })
    }

    const props = {
        show,
        value: OTP,
        onChangeOTP,
        closeModal,
        errorForm,
        isLoading,
        onSubmit,
    }

    return <Verification {...props} />
}
